import { css } from "@emotion/css";
import { PropsWithChildren, createContext } from "react";

interface FilterChipGroupOptions {
  showSelectedIcon?: boolean;
}

export const FilterChipGroupContext = createContext<FilterChipGroupOptions>({});

interface Props extends FilterChipGroupOptions, PropsWithChildren {}

export function FilterChipGroup(props: Props) {
  return (
    <FilterChipGroupContext.Provider
      value={{ showSelectedIcon: props.showSelectedIcon }}
    >
      <div className={styles.group}>{props.children}</div>
    </FilterChipGroupContext.Provider>
  );
}

const styles = {
  group: css({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    rowGap: "var(--space-3)",
    columnGap: "var(--space-2)",
  }),
};
